export enum StatusBalanceDialog {
  INIT = 'init',
  PROFESSIONAL = 'professional',
  CREDIT = 'credit',
  OTHER = 'other',
  NEQUI = 'nequi',
  WOMPI = 'wompi',
  DAVIPLATA = 'daviplata',
  PSE = 'pse'
}
